import { render, staticRenderFns } from "./MergeShops.vue?vue&type=template&id=95aa590c&scoped=true&"
import script from "./MergeShops.vue?vue&type=script&lang=js&"
export * from "./MergeShops.vue?vue&type=script&lang=js&"
import style0 from "./MergeShops.vue?vue&type=style&index=0&id=95aa590c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa590c",
  null
  
)

export default component.exports